/**
 * Checks sessionStorage for a pending gift action and returns
 * the artist profile route if one exists, otherwise null.
 */
export function getPendingGiftRedirect(): string | null {
  try {
    const pending = sessionStorage.getItem("pending_gift_action");
    if (pending) {
      const { artistUsername } = JSON.parse(pending);
      if (artistUsername) {
        return `/profiles/${artistUsername}?tab=support-me`;
      }
    }
  } catch {
    // parse error, ignore
  }
  return null;
}
